import { addCalendarDays, dayjsUtc, londonToday } from 'lib/dayjs'

export const getDateRangePresetOptions = () => {
  return [
    {
      label: 'Overdue',
      name: 'overdue',
      gte: '2019-01-01',
      lte: addCalendarDays(londonToday(), -1),
    },
    {
      label: 'Today',
      name: 'today',
      gte: londonToday(),
      lte: londonToday(),
    },
    {
      label: 'Tomorrow',
      name: 'tomorrow',
      gte: addCalendarDays(londonToday(), 1),
      lte: addCalendarDays(londonToday(), 1),
    },
    {
      label: 'Next 3 days',
      name: 'nextThreeDays',
      gte: londonToday(),
      lte: addCalendarDays(londonToday(), 3),
    },
    {
      label: 'Next 7 days',
      name: 'nextSevenDays',
      gte: londonToday(),
      lte: addCalendarDays(londonToday(), 7),
    },
  ]
}

export const getDateRange = (preset) => {
  const selectedOptions = getDateRangePresetOptions().filter(
    (option) => preset[option.name]
  )

  const gte = selectedOptions.reduce((acc, option) => {
    if (!acc) return option.gte
    if (option.gte < acc) return option.gte
    return acc
  }, '')

  const lte = selectedOptions.reduce((acc, option) => {
    if (!acc) return option.lte
    if (option.lte > acc) return option.lte
    return acc
  }, '')

  return { gte, lte }
}

export const getDaysFromToday = (date) => {
  const daysAgo = dayjsUtc().diff(dayjsUtc(date), 'day')

  if (daysAgo === 1) return '1 day'
  return `${daysAgo} days`
}

export const formatGraphQLmeta = (result) => {
  if (result) {
    return {
      page: { total: result.totalCount },
      cursors: {
        pageStart: result.pageInfo.startCursor,
        pageEnd: result.pageInfo.endCursor,
      },
    }
  }
}
